import React from "react";
import { purple } from "@mui/material/colors";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import GenericSupportListing from "../GenericSupportListing/GenericSupportListing";

// ===================== CONSTANTS =====================
const PAGE_TITLE = "My Approvals History";
const API_ENDPOINT = "/support-requests/assigned/all";

const AllRequestsPage = () => {
  return (
    <GenericSupportListing
      pageTitle={PAGE_TITLE}
      apiRoute={API_ENDPOINT}
      showResponseAction={true}
      showViewAction={true}
      PageIcon={<HistoryRoundedIcon color="white" fontSize="large" />}
      iconColor={purple[700]}
    />
  );
};

export default AllRequestsPage;
